import React from "react";
import ProductItem from "components/product/item";
import ExpandedProductItem from "./expanded-product-item";
import Minimalistic from "./minimalistic";

const ProductCard = ({ product, cardStyle }) => {
	if (cardStyle === "expanded") {
		return <ExpandedProductItem product={product}  />;
	}

	if (cardStyle === "minimalistic") {
		return <Minimalistic product={product} />;
	}

	return (
		<ProductItem
			product={product}
			showModal={false}
			className={"min-w-72 sm:min-w-auto"}
			titleClass="text-base font-bold md:text-lg text-left"
			priceClass="text-base ml-2 text-end"
		/>
	);
};

export default ProductCard;
